import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import { useLocatorTranslations } from "@locators/components/shared/hooks/useLocatorTranslations";
import type { MobileViewOnChange } from "@locators/components/shared/hooks/useMobileView";
import { useMobileView } from "@locators/components/shared/hooks/useMobileView";
import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";

import styles from "./ViewSwitch.module.scss";

type ViewSwitchType = MobileViewOnChange & HTMLAttributes<HTMLDivElement>;

export const ViewSwitch = forwardRef<HTMLDivElement, ViewSwitchType>(function ViewSwitch(
  { onChangeResultType, ...rest },
  ref
) {
  const { __ } = useLocatorTranslations();
  const { storeLocatorLayoutVersion = "v1" } = useConfig();
  const { mobileView, onMobileViewChange } = useMobileView({ onChangeResultType });

  const isV2 = storeLocatorLayoutVersion === "v2";

  return (
    <div {...rest}>
      <div
        className={classNames(styles.mobileViewSwitchContainer)}
        role="group"
        aria-label={__("storelocator.mobile_view_switch.group_aria_label")}
        ref={ref}
      >
        <input
          type="radio"
          name="mobile-view"
          value="map"
          checked={mobileView === "map"}
          onChange={onMobileViewChange}
          className={classNames(styles.switchButtonInput, styles.visuallyHidden)}
          id="storeLocatorMobileViewSwitch-map"
          aria-label={__("storelocator.mobile_view_switch.map_aria_label")}
        />
        <label className={styles.mobileViewSwitchButtonLabel} htmlFor="storeLocatorMobileViewSwitch-map">
          <span
            className={classNames(styles.mobileViewSwitchButton, styles.mobileViewSwitchButtonMap, {
              [styles.mobileViewSwitchButtonV2]: isV2,
            })}
          >
            {__("storelocator.mobile_view_switch.map")}
          </span>
        </label>
        <input
          type="radio"
          name="mobile-view"
          value="list"
          checked={mobileView === "list"}
          onChange={onMobileViewChange}
          className={classNames(styles.switchButtonInput, styles.visuallyHidden)}
          id="storeLocatorMobileViewSwitch-list"
          aria-label={__("storelocator.mobile_view_switch.list_aria_label")}
        />
        <label className={styles.mobileViewSwitchButtonLabel} htmlFor="storeLocatorMobileViewSwitch-list">
          <span
            className={classNames(styles.mobileViewSwitchButton, styles.mobileViewSwitchButtonList, {
              [styles.mobileViewSwitchButtonV2]: isV2,
            })}
          >
            {__("storelocator.mobile_view_switch.list")}
          </span>
        </label>
      </div>
    </div>
  );
});
